import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { squareOrangeButton, blueGradient } from '../../styles/reusable.style'
import PropTypes from 'prop-types'

const StyledLinkButton = styled(Link)`
	${squareOrangeButton()};
	background: ${({ secondary }) => (secondary ? blueGradient() : null)};
`

const LinkButton = props => (
	<StyledLinkButton {...props}>{props.children}</StyledLinkButton>
)

LinkButton.propTypes = {
	to: PropTypes.string.isRequired
}

export default LinkButton
